/**
 * Allows for views to be reordered without re-rendering.
 * When view is removed and then added at another index right away,
 * it will simply be re-attached at another place in DOM.
 */
define('uikit/collections/reordarable.collection.view',['require','exports','module','marionette','underscore'],function(require, exports, module) {
  var Mn = require('marionette');
  var _  = require('underscore');

  var ReordarableCollectionView = Mn.CollectionView.extend({

    // temporarily cache child view, so it can be later reused by add
    // (if add operation runs in the same tick)
    _cacheAndRemoveChildView: function(view) {
      // flag will be reset by the view if it has been re-added
      view._addedFromCache = false;

      // view will be cached until for a small amount of time to check
      // if add operation has been called and if it has, view will not
      // be re-rendered.
      var self = this;
      _.delay(function() {
        if (!view._addedFromCache) {
          self.removeChildView(view);
        }
      });
    },

    // override Marionette
    _onCollectionRemove: function _onCollectionRemove(model) {
      var view = this.children.findByModel(model);
      this._cacheAndRemoveChildView(view);
      this.checkEmpty();
    },

    // Handle a child added to the collection
    _onCollectionAdd: function(child, collection, opts) {
      // `index` is present when adding with `at` since BB 1.2; indexOf fallback for < 1.2
      var index = opts.at !== undefined && (opts.index || collection.indexOf(child));

      // When filtered or when there is no initial index, calculate index.
      if (this.getOption('filter') || index === false) {
        index = _.indexOf(this._filteredSortedModels(index), child);
      }

      if (this._shouldAddChild(child, index)) {
        this.destroyEmptyView();

        // override default: check if view is cached and add it from cache
        var cachedView = this.children.findByModel(child);
        if (cachedView) {
          this._addChildFromCache(cachedView, index);
        }
        else {
          var ChildView = this.getChildView(child);
          this.addChild(child, ChildView, index);
        }
      }
    },

    _addChildFromCache: function(view, index) {
      // increment indices of views after this one
      view._addedFromCache = true;

      this._updateIndicesOnAddCachedView(view, index);

      this.triggerMethod('before:add:child', view);
      this._addChildView(view, index);
      this.triggerMethod('add:child', view);

      view._parent = this;

      return view;
    },

    // Internal method. This decrements or increments the indices of views after the
    // added view to keep in sync with the collection. Takes into account that
    // current view may be still cached inside children
    _updateIndicesOnAddCachedView: function(view, index) {
      if (!this.getOption('sort')) {
        return;
      }

      var oldViewIndex = view._index;
      view._index = index;

      // update the indexes of other views
      this.children.each(function(otherView) {
        if (otherView != view) {
          // if view moved ahead
          if (oldViewIndex < view._index) {
            // all views that are now behind new view, need to decrement index
            if (otherView._index > oldViewIndex && otherView._index <= view._index) {
              otherView._index += -1;
            }
          }
          // if view moved behind
          else {
            // all views that are now ahead of new view, need to increment index
            if (otherView._index >= view._index && otherView._index < oldViewIndex) {
              otherView._index += 1;
            }
          }
        }
      });
    },

    // override Marionette
    renderChildView: function(view, index) {
      // only render view if it hasn't been added from cache
      if(!view._addedFromCache) {
        if (!view.supportsRenderLifecycle) {
          Marionette.triggerMethodOn(view, 'before:render', view);
        }
        view.render();
        if (!view.supportsRenderLifecycle) {
          Marionette.triggerMethodOn(view, 'render', view);
        }
      }
      this.attachHtml(this, view, index);
      return view;
    }
  });

  module.exports = ReordarableCollectionView;
});

